import {
  SET_EXPORT_MESSAGE,
} from "typeConstants";

const setRunningExports = (exportMessage) => { 
  return dispatch => {
    dispatch({
      type: SET_EXPORT_MESSAGE,
      payload: exportMessage
    });
  };
};

export {
  setRunningExports
};
